import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../../contexts/AuthContext';
import { setTokenExpiry } from '../../../services/api';

const { Text } = Typography;

interface AdminLoginFormProps {
    onSuccess?: () => void;
}

interface LoginData {
    username: string;
    password: string;
}

export const AdminLoginForm: React.FC<AdminLoginFormProps> = ({ onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const { updateUser } = useAuth();

    const handleSubmit = async (values: LoginData) => {
        setLoading(true);

        try {
            // Отправляем запрос на backend
            const apiUrl = process.env.REACT_APP_API_URL || '/api';
            const response = await fetch(`${apiUrl}/admin/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: values.username,
                    password: values.password
                })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // Сохраняем JWT токены
                localStorage.setItem('accessToken', data.accessToken);
                localStorage.setItem('adminToken', data.accessToken); // Дублируем для админского API
                if (data.refreshToken) {
                    localStorage.setItem('refreshToken', data.refreshToken);
                }
                // Устанавливаем время истечения токена
                setTokenExpiry();

                // Создаем объект пользователя в формате, который ожидает AuthContext
                const userData = {
                    id: data.data.id,
                    login: data.data.username,
                    fullName: `${data.data.firstName} ${data.data.lastName}`,
                    role: data.data.role,
                    status: data.data.status,
                    isEmailVerified: true,
                    isPhoneVerified: true
                };

                console.log('AdminLoginForm: response data =', data);
                console.log('AdminLoginForm: userData =', userData);

                localStorage.setItem('user', JSON.stringify(userData));

                // Обновляем контекст напрямую, так как это админ-вход
                updateUser(userData);

                message.success('Добро пожаловать, супер-администратор!');

                if (onSuccess) {
                    onSuccess();
                }
            } else {
                message.error(data.message || 'Неверный логин или пароль');
            }
        } catch (error) {
            console.error('Ошибка авторизации:', error);
            message.error('Ошибка при входе в систему');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            name="admin-login"
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
        >
            <Form.Item
                name="username"
                label="Логин"
                rules={[
                    { required: true, message: 'Введите логин' }
                ]}
            >
                <Input
                    prefix={<UserOutlined />}
                    placeholder="admin"
                />
            </Form.Item>

            <Form.Item
                name="password"
                label="Пароль"
                rules={[
                    { required: true, message: 'Введите пароль' }
                ]}
            >
                <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="123123"
                />
            </Form.Item>

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="w-full"
                >
                    Войти как супер-админ
                </Button>
            </Form.Item>

            <div className="text-center mt-4">
                <Text type="secondary" className="text-xs">
                    Логин: <strong>admin</strong> | Пароль: <strong>123123</strong>
                </Text>
            </div>
        </Form>
    );
};
